// Recovered compiled webpack factory 91573. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  function n(e) {
    return new Promise((t, r) => {
      if (document.querySelector(`script[src="${e}"]`)) return void t();
      let n = document.createElement("script");
      ((n.src = e),
        (n.async = !0),
        (n.onload = () => t()),
        (n.onerror = (e) => {
          (console.error("Error loading script", e), r(e));
        }),
        document.head.appendChild(n));
    });
  }
  r.d(t, { H: () => u });
  var a = class e {
      #e;
      #t;
      #r = 0;
      constructor() {
        let { promise: t, resolve: r } = e.#n();
        ((this.#e = t),
          (this.#t = r),
          this.#a(),
          window.addEventListener("online", this.#o),
          window.addEventListener("visibilitychange", this.#o));
      }
      getChallenge = async () => (
        await this.#i(),
        await this.#e.then((e) => ("function" == typeof e ? e() : e))
      );
      #o = () => {
        if (document.hidden) return;
        let { promise: t, resolve: r } = e.#n();
        ((this.#e = t), (this.#t = r), (window.V_C = []), (window.V_C.push = r));
        let n = document.querySelector('script[src*="c.js"]');
        (n && n.remove(), (this.#r += 1));
      };
      #a = () => {
        if (window.V_C) {
          let e = window.V_C.pop();
          e && this.#t(e);
        } else ((window.V_C = []), (window.V_C.push = this.#t));
      };
      #i = () => {
        let e = new URL(
          "/149e9513-01fa-4fb0-aad4-566afd725d1b/2d206a39-8ed7-437e-a3be-862e0f06eea3/a-4-a/c.js",
          window.location.origin,
        );
        return (
          e.searchParams.set("i", String(this.#r)),
          e.searchParams.set("v", String(3)),
          e.searchParams.set("h", window.location.host),
          n(e.pathname + e.search)
        );
      };
      #s = () => {
        window.V_C = void 0;
      };
      static #n() {
        let e, t;
        return {
          promise: new Promise((r, n) => {
            ((e = r), (t = n));
          }),
          resolve: e,
          reject: t,
        };
      }
    },
    o = class e {
      #e = !1;
      #t;
      constructor(e) {
        this.#t = e;
      }
      get loaded() {
        return this.#e;
      }
      load = async () => {
        this.#e || (await this.#o());
      };
      #r = () => {
        if (typeof globalThis.window > "u") throw Error("KPSDK is not available in the server");
        if (!window.KPSDK) throw Error("KPSDK is not loaded");
        let t = this.#t.map((t) => {
          let r = e.#a(t.path);
          return { domain: r.host, path: r.pathname, method: t.method };
        });
        try {
          window.KPSDK.configure(t);
        } catch (e) {
          console.error("Error configuring KPSDK...", e);
        }
      };
      #o = async () => {
        let e = this;
        return new Promise((t, r) => {
          let a = () => {
              (document.removeEventListener("kpsdk-load", a), this.#r());
            },
            o = () => {
              (document.removeEventListener("kpsdk-ready", o), (e.#e = !0), t());
            };
          (document.addEventListener("kpsdk-load", a, { once: !0 }),
            document.addEventListener("kpsdk-ready", o, { once: !0 }),
            n(
              "/149e9513-01fa-4fb0-aad4-566afd725d1b/2d206a39-8ed7-437e-a3be-862e0f06eea3/p.js",
            ).catch((e) => {
              (document.removeEventListener("kpsdk-load", a),
                document.removeEventListener("kpsdk-ready", o),
                r(e));
            }));
        });
      };
      static #a(e) {
        let t;
        try {
          t = new URL(e);
        } catch {
          t = new URL(e, location.origin);
        }
        return t;
      }
    },
    i = (e) => {
      let t = e
        .replace(/[.?+^$[\]\\(){}|-]/g, "\\$&")
        .split("*")
        .join(".*");
      return RegExp(`^${t}$`);
    },
    s = ({ path: e, pattern: t }) => -1 !== e.search(t);
  async function l(e, t, r) {
    let n = XMLHttpRequest.prototype.open,
      a = XMLHttpRequest.prototype.send;
    ((XMLHttpRequest.prototype.open = function (e, t, r, a, o) {
      return (
        (this._requestUrl = t.toString()),
        (this._requestMethod = e),
        n.call(this, e, t, r ?? !0, a, o)
      );
    }),
      (XMLHttpRequest.prototype.send = async function (n) {
        let o = this._requestUrl;
        if (!o || this._isReexecution) return a.call(this, n);
        let l = new URL(o, location.href),
          u = l.origin === location.origin,
          c = this._requestMethod ?? "GET",
          f = r.find((e) => {
            let t = s({ path: l.pathname, pattern: i(e.path) }),
              r = e.method.toLowerCase() === c.toLowerCase() || "*" === e.method;
            return t && r;
          });
        if (!f || !u) return a.call(this, n);
        let d = await e.getChallenge();
        if (
          (this.setRequestHeader("x-is-human", JSON.stringify(d)),
          this.setRequestHeader("x-path", l.pathname),
          this.setRequestHeader("x-method", c),
          0 !== d.b ||
            t.loaded ||
            ((1 === d.d || f?.advancedOptions?.checkLevel === "deepAnalysis") && (await t.load()),
            !t.loaded))
        )
          return a.call(this, n);
        (this.setRequestHeader("x-is-human", JSON.stringify(d)),
          this.setRequestHeader("x-path", l.pathname),
          this.setRequestHeader("x-method", c));
        let p = new XMLHttpRequest();
        return (
          (p._isReexecution = !0),
          p.open(c, o, !0),
          p.setRequestHeader("x-is-human", JSON.stringify(d)),
          p.setRequestHeader("x-path", l.pathname),
          p.setRequestHeader("x-method", c),
          this.timeout && (p.timeout = this.timeout),
          this.responseType && (p.responseType = this.responseType),
          this.withCredentials && (p.withCredentials = this.withCredentials),
          (p.onreadystatechange = () => {
            (Object.defineProperty(this, "readyState", {
              value: p.readyState,
              writable: !0,
              configurable: !0,
            }),
              p.readyState === XMLHttpRequest.DONE &&
                (Object.defineProperty(this, "status", {
                  value: p.status,
                  writable: !0,
                  configurable: !0,
                }),
                Object.defineProperty(this, "statusText", {
                  value: p.statusText,
                  writable: !0,
                  configurable: !0,
                }),
                Object.defineProperty(this, "response", {
                  value: p.response,
                  writable: !0,
                  configurable: !0,
                }),
                Object.defineProperty(this, "responseText", {
                  value: p.responseText,
                  writable: !0,
                  configurable: !0,
                }),
                Object.defineProperty(this, "responseXML", {
                  value: p.responseXML,
                  writable: !0,
                  configurable: !0,
                }),
                (this.getAllResponseHeaders = () => p.getAllResponseHeaders()),
                (this.getResponseHeader = (e) => p.getResponseHeader(e))),
              this.onreadystatechange &&
                this.onreadystatechange.call(this, new Event("readystatechange")));
          }),
          (p.onload = (e) => {
            this.onload && this.onload.call(this, e);
          }),
          (p.onerror = (e) => {
            this.onerror && this.onerror.call(this, e);
          }),
          (p.onabort = (e) => {
            this.onabort && this.onabort.call(this, e);
          }),
          (p.ontimeout = (e) => {
            this.ontimeout && this.ontimeout.call(this, e);
          }),
          (p.onloadstart = (e) => {
            this.onloadstart && this.onloadstart.call(this, e);
          }),
          (p.onloadend = (e) => {
            this.onloadend && this.onloadend.call(this, e);
          }),
          (p.onprogress = (e) => {
            this.onprogress && this.onprogress.call(this, e);
          }),
          p.send(n)
        );
      }));
  }
  function u({ protect: e = [] }) {
    let t;
    for (let t of e)
      if (
        t.advancedOptions?.checkLevel !== void 0 &&
        "deepAnalysis" !== t.advancedOptions.checkLevel &&
        "basic" !== t.advancedOptions.checkLevel
      )
        throw Error(
          `Invalid checkLevel "${t.advancedOptions.checkLevel}" for route "${t.path}". Must be one of: deepAnalysis, basic`,
        );
    let r = new a(),
      n = new o(e);
    (l(r, n, e).catch((e) => {
      console.error("Error patching XMLHttpRequest:", e);
    }),
      (t = window.fetch),
      (window.fetch = async (a, o) => {
        let l = new URL(a instanceof Request ? a.url : a, location.href),
          u = l.origin === location.origin,
          c = o?.method ?? (a instanceof Request ? a.method : "GET"),
          f = e.find((e) => {
            let t = s({ path: l.pathname, pattern: i(e.path) }),
              r = e.method.toLowerCase() === c.toLowerCase() || "*" === e.method;
            return t && r;
          });
        if (null == f || !u) return t(a, o);
        let d = await r.getChallenge(),
          p = new Headers(o?.headers || (a instanceof Request ? a.headers : void 0));
        (p.set("x-is-human", JSON.stringify(d)), p.set("x-path", l.pathname), p.set("x-method", c));
        let h = { ...o, headers: p };
        return n.loaded || 0 !== d.b
          ? t(a, h)
          : 1 === d.d || f?.advancedOptions?.checkLevel === "deepAnalysis"
            ? (await n.load(), window.fetch(a, h))
            : t(a, h);
      }));
  }
}
